import { render, staticRenderFns } from "./report-merchant.vue?vue&type=template&id=1b94456c&scoped=true"
import script from "./report-merchant.vue?vue&type=script&lang=js"
export * from "./report-merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94456c",
  null
  
)

export default component.exports